import { createContext, useContext } from 'react';

export interface PanelContextType {
  inPanel: boolean;
  inModal: boolean;
}

export const defaultPanelContext: PanelContextType = {
  inPanel: false,
  inModal: false,
};

export const PanelContext =
  createContext<PanelContextType>(defaultPanelContext);

export function usePanelContext() {
  return useContext(PanelContext);
}

export const { Consumer, Provider } = PanelContext;
